import axios from "@/utils/axios.js";

function removeFile(id) {
  return new Promise((resolve, reject) => {
    axios
      .delete(`files/${id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

//////////

/**
 * Прикрепление билета
 * @param {Number} ticket_statuses_id
 * @param {Number} expenses_id
 * @param {Number} transports_id
 * @param {Number} loyalty_card_id
 * @param {String} number_flight
 * @param {String} number_ticket
 * @param {String} price
 * @param {String} start_date
 * @param {String} finish_date
 * @param {Number} order_passenger_id
 * @param {Number} point_id
 * @param {String} tax
 * @param {String} penalty
 */
function CreateTicket(
    ticket_statuses_id,
    expenses_id,
    transports_id,
    loyalty_card_id,
  number_flight,
  number_ticket,
  price,
  start_date,
  finish_date,
  order_passenger_id,
  point_id,
  tax,
  penalty
) {
  const ticketData = {
    ticket_statuses_id,
    expenses_id,
    transports_id,
    loyalty_card_id,
    number_ticket,
    number_flight,
    price,
    start_date,
    finish_date,
    order_passenger_id,
    point_id,
    tax,
    penalty,
  };
  return new Promise((resolve, reject) => {
    axios
      .post(`tickets`, ticketData)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * Изменение билета
 * @param {Number} ticket_statuses_id
 * @param {Number} expenses_id
 * @param {Number} transports_id
 * @param {Number} loyalty_card_id
 * @param {Number} ticketId
 * @param {String} number_ticket
 * @param {String} number_flight
 * @param {String} price
 * @param {String} start_date
 * @param {String} finish_date
 * @param {Number} order_passenger_id
 * @param {Number} point_id
 * @param {String} tax
 * @param {String} penalty
 */
function UpdateTicket(
    ticket_statuses_id,
    expenses_id,
    transports_id,
    loyalty_card_id,
  ticketId,
  number_flight,
  number_ticket,
  price,
  start_date,
  finish_date,
  order_passenger_id,
  point_id,
  tax,
  penalty
) {
  const ticketData = {
    ticket_statuses_id,
    expenses_id,
    transports_id,
    loyalty_card_id,
    ticketId,
    number_ticket,
    number_flight,
    price,
    start_date,
    finish_date,
    order_passenger_id,
    point_id,
    tax,
    penalty,
  };
  return new Promise((resolve, reject) => {
    axios
      .put(`tickets/${ticketId}`, ticketData)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

function AddTicketFile(ticketId, file) {
  const data = new FormData();
  data.append("tickets[]", file);

  return new Promise((resolve, reject) => {
    axios
      .post(`tickets/${ticketId}/upload`, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

function getOrderTicketsInfo(orderId) {
  return new Promise((resolve, reject) => {
    axios
      .get(`tickets/prepare/${orderId}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

function copyNumberFlights(orderId, pointId, passengers, flightNumber, startDate, finishDate) {
  return new Promise((resolve, reject) => {
    axios
      .patch(`/tickets/copy-number`, {
        "order_id": orderId,
        "point_id": pointId,
        "passenger": passengers,
        'number_flight': flightNumber,
        'start_date': startDate,
        'finish_date': finishDate
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

function getTicketInfo(ticketId) {
  return new Promise((resolve, reject) => {
    axios
      .get(`tickets/${ticketId}?expand=tickets,point`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

function getAllTicketsInfo(orderId, userId, modelType) {
  const params = {
    "search[Order]": orderId || null,
    "search[Passenger]": userId && modelType ? `${modelType},${userId}` : null,
  };
  return new Promise((resolve, reject) => {
    axios
      .get(`tickets?expand=point,tickets,transport,status,expense,history,order_passenger,loyalty_card`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

function getBase64(fileId) {
  return new Promise((resolve, reject) => {
    axios
      .get(`files/${fileId}/base64`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  })
}

function setStatusReturn(id, data) {
  return new Promise((resolve, reject) => {
    axios.post(`/tickets-history/create/${id}`, data)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
  })
}

export {
  removeFile,
  CreateTicket,
  UpdateTicket,
  AddTicketFile,
  setStatusReturn,
  getOrderTicketsInfo,
  getTicketInfo,
  copyNumberFlights,
  getAllTicketsInfo,
  // getTicketStatuses,
  getBase64
};
